import { z } from 'zod'

export const MEDIA_VISIBILITIES = ['public', 'private'] as const
export const MEDIA_ASSET_STATUSES = ['pending', 'ready'] as const
export const MEDIA_UPLOAD_KINDS = ['image', 'document', 'audio'] as const

export const MEDIA_IMAGE_MIME_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/avif',
] as const
export const MEDIA_AUDIO_MIME_TYPES = ['audio/webm', 'audio/ogg', 'audio/mp4'] as const

/** Largest accepted file per upload kind, in bytes. */
export const MEDIA_MAX_SIZE = {
  image: 10 * 1024 * 1024,
  document: 25 * 1024 * 1024,
  audio: 10 * 1024 * 1024,
} as const satisfies Record<(typeof MEDIA_UPLOAD_KINDS)[number], number>
export const MEDIA_AUDIO_MAX_SECONDS = 15

export const prepareMediaImageUploadSchema = z.object({
  mimeType: z.enum(MEDIA_IMAGE_MIME_TYPES),
  size: z.number().int().positive().max(MEDIA_MAX_SIZE.image),
})

export type MediaVisibility = (typeof MEDIA_VISIBILITIES)[number]
export type MediaAssetStatus = (typeof MEDIA_ASSET_STATUSES)[number]
export type MediaUploadKind = (typeof MEDIA_UPLOAD_KINDS)[number]
export type MediaImageMimeType = (typeof MEDIA_IMAGE_MIME_TYPES)[number]
export type PrepareMediaImageUploadInput = z.infer<typeof prepareMediaImageUploadSchema>
